export default __webpack_public_path__ + "static/the-block-240-3751882087e9e9e35542b2deac0e23d4.png";